<div class="tt-o-search-field" :class="{ 'tt-o-search-field--with-search-icon': showSearchIcon }">
  <tt-icon v-if="showSearchIcon" name="search" size="sm"></tt-icon>
  <input v-if="!multiline" 
         ref="field"
         @input="update"
         class="tt-o-search-field__input"
         type="text"
         :id="fieldId"
         :aria-describedby="describedBy"
         :placeholder="placeholder"
         :value="modelValue">
  <div v-if="multiline"
       ref="field"
       contenteditable="true"
       class="tt-o-search-field__input"
       :id="fieldId"
       @keyup="update"
       role="textbox"
       :aria-labelledby="labelId"
       :aria-describedby="describedBy"
       aria-multiline="true"
       tabindex="0"></div>
  <tt-button v-if="modelValue" type="icon" class="tt-o-search-field__clear" :aria-label="$msg('searchField.clearText')" @click="clearText">
    <tt-icon name="close" size="xxs"></tt-icon>
  </tt-button>
</div>
